module.exports = "/static/js/d9d22342f3d073eaace5ab391624e956.png";